import '@i18n';
import { init as initAppHeight } from './app-height';
import { init as initChartJS } from './chartjs';
import FacebookSDK from './facebook';
import { init as initGoogleMap } from './init-google-map';
import PostHogManager from './posthog-manager';
import GTManager from './gtm';
import './yup-config';

const initWidgets = () => {
    initAppHeight();
    GTManager.init();
    FacebookSDK.init();
    initChartJS();

    initGoogleMap();
    PostHogManager.init();
};

export default initWidgets;
